import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { surveysApi } from '../api'

export default function Surveys() {
  const navigate = useNavigate()

  const { data: sites = [] } = useQuery({
    queryKey: ['surveys'],
    queryFn: () => surveysApi.getSites().then(r => r.data),
  })

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-gray-900">설비조사</h2>
          <p className="text-xs text-gray-400 mt-1">현장별 설비조사 데이터</p>
        </div>
      </div>

      <div className="bg-surface rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-xs">
            <tr>
              <th className="text-left px-4 py-3">현장명</th>
              <th className="text-left px-4 py-3">설비</th>
              <th className="text-left px-4 py-3">새 업로드</th>
              <th className="text-left px-4 py-3">최근 수신/수정</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {sites.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400 text-xs">
                데이터가 없습니다.
              </td></tr>
            )}
            {sites.map(s => (
              <tr key={s.id} onClick={() => navigate(`/surveys/${s.id}`)}
                className="hover:bg-gray-50 cursor-pointer">
                <td className="px-4 py-3 font-medium text-gray-800">{s.name}</td>
                <td className="px-4 py-3 text-gray-600">{s.equipmentCount}건</td>
                <td className="px-4 py-3">
                  {s.newerUploadCount > 0 ? (
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                      {s.newerUploadCount}건
                    </span>
                  ) : (
                    <span className="text-gray-300 text-xs">—</span>
                  )}
                </td>
                <td className="px-4 py-3 text-gray-400 text-xs">{new Date(s.updatedAt).toLocaleString('ko-KR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
